import {
  getTeamApp,
  isTeamAppInitialized,
  type TeamAppProps,
} from "./teamAppZoid";

// Public surface for host bridges: every hook under `src/host/` reads
// from `getHost()` so the "is the zoid bridge ready?" check lives in
// exactly one place. Returns null when running standalone (no host) so
// hooks can degrade to in-app fallbacks (AntD toast / Modal.confirm).

export type HostProps = TeamAppProps;

export function getHost(): HostProps | null {
  if (!isTeamAppInitialized()) return null;
  return getTeamApp();
}
